<template>
  <div class="mentoring-page" :style="{'background-image': `url(${MainBg})`}">
    <v-container>
      <v-row style="position: relative;">
        <!-- <div class="hero-background" v-if="$vuetify.breakpoint.mdAndUp"><span v-for="i in 12" :key="i">{{$root.siteSettings.mentoringPageTitle}}&nbsp;</span></div> -->
        <v-col
          cols="12"
          sm="10"
          offset-sm="1"
          lg="8"
          offset-lg="2"
        >
        <h1 class="mb-4">{{$root.siteSettings.mentoringPageTitle}}</h1>
        <MarkdownBlock :text="$root.siteSettings.mentoringPageIntro" />
        <MentoringResume
          ref="mainVideo"
          v-if="Mentorings"
          :title="Mentorings[0][`${$language.current}Title`]"
          :description="Mentorings[0][`${$language.current}Description`]"
          :videoUrl="Mentorings[0].videoUrl"
          :image="Mentorings[0].image"
          @playing="onPlay(0)"
          @pause="onPause(0)"
          @ended="onPause(0)"
          big
        />
        <v-row v-if="Mentorings && Mentorings.length > 1" class="mt-md-12">
          <template v-for="(mentoring, i) in Mentorings" >
            <v-col
              cols="12"
              md="6"
              v-if="i > 0"
              :key="i"
            >
              <MentoringResume
                ref="videos"
                :title="mentoring[`${$language.current}Title`]"
                :description="mentoring[`${$language.current}Description`]"
                :videoUrl="mentoring.videoUrl"
                :image="mentoring.image"
                @playing="onPlay(i)"
                @pause="onPause(i)"
                @ended="onPause(i)"
              />
            </v-col>
          </template>

        </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { MarkdownBlock } from '@monogrid/vue-lib'
import ListMentoringEN from '@/graphql/ListMentoring_EN.gql'
import ListMentoringIT from '@/graphql/ListMentoring_IT.gql'

import MentoringResume from '@/molecules/MentoringResume'
import MainBg from '@/assets/img/main-bg.jpg'

export default {
  name: 'MentoringPage',
  components: { MarkdownBlock, MentoringResume },
  data () {
    return {
      MainBg
    }
  },
  apollo: {
    Mentorings: {
      query () {
        if (this.$language.current === 'en') {
          return ListMentoringEN
        } else {
          return ListMentoringIT
        }
      },
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'priority'
        }
      },
      update: data => {
        return data.Mentorings.items
      }
    }
  },
  methods: {
    onPlay (i) {
      if (Number.isFinite(this.isPlaying)) {
        if (this.isPlaying === 0) {
          this.$refs.mainVideo.pause()
        } else {
          this.$refs.videos[this.isPlaying - 1].pause()
        }
      }
      this.isPlaying = i
    },
    onPause (i) {
      if (this.isPlaying === i) {
        this.isPlaying = false
      }
    }
  },
  metaInfo () {
    const pageName = 'mentoring'
    const imageMeta = JSON.parse(this.$root.siteSettings[`${pageName}PageShareImage`].metaData)
    return {
      // home page browser title
      title: this.$root.siteSettings[`${pageName}PageTitle`],
      meta: [
        { vmid: 'description', name: 'description', content: this.$root.siteSettings[`${pageName}PageShareDescription`] },
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.$root.siteSettings[`${pageName}PageTitle`]} | ${this.$root.siteSettings.siteTitle}` },
        { vmid: 'ogdescription', property: 'og:description', content: this.$root.siteSettings[`${pageName}PageShareDescription`] },
        { vmid: 'ogimage', property: 'og:image', content: `https://${this.$root.process.env.SERVICE_TARGET_DOMAIN}/media/${this.$root.siteSettings[`${pageName}PageShareImage`].id}` },
        { vmid: 'ogimagetype', property: 'og:image:type', content: this.$root.siteSettings[`${pageName}PageShareImage`].mimeType },
        { vmid: 'ogimageheight', property: 'og:image:width', content: imageMeta['image-width'] },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: imageMeta['image-height'] }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.mentoring-page {
  background-color: $c-secondary;
  padding: 200px 0 150px;
  min-height: 100%;
  background-attachment: fixed;
  background-size: cover;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  font-size: 30vw;
  opacity: 0.05;
  font-family: $heading-font-family;
  user-select: none;
  pointer-events: none;
  animation: hero-title-motion 20s linear forwards infinite;
}
</style>
